<template>
  <div>
    <div class="modal">
      <div class="modal__title">
        Je valide la réception<br>de ma commande
      </div>
      <div class="modal__picto">
        <img src="/static/img/pictos/order-valid-recept.svg">
      </div>
      <div class="modal__btns">
        <a href="" class="modal__btn modal__btn--valid" @click.prevent="validReceptOrder(id)">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" class="modal__btn modal__btn--delete" @click.prevent="closeModal()">
          <span>Non</span>
          <img src="/static/img/pictos/supprimer.svg" class="">
        </a>
      </div>
    </div>
    <div class="overlay" @click.prevent="closeModal()">
      <i></i>
    </div>
  </div>
</template>

<script>


export default {
  name: "OrderModal",
  props: [
    "type",
    "id",
    "item",
  ],
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  mounted() {

  },
  methods: {
    closeModal(){
      this.$emit("close")
    },
    validReceptOrder(id){
      this.$http.patch('order/valid-recept/'+id, {
        status: 4,
        item: this.item
      }, {
        redirectOnSuccess: {name: 'OrderList'}
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: white;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: white;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(25, 45, 85, 0.95);
    z-index: 800;
  }

  .modal { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: white; height: 320px; width: 320px; z-index: 900; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center;
    &__title{ font-family: 'ClanFFBlack'; font-size: 20px; color: $color1; margin-top: auto; }
    &__picto{ width: 120px; margin-top: 20px; margin-bottom: auto; }
    &__btns{ display: flex; height: 50px; width: 100%; margin-bottom: -1px; }
    &__btn{ width: 50%; height: 100%; display: flex; align-items: center; justify-content: center;
      img{ width: 30px; }
      span{ font-family: 'ClanProBold'; font-size: 14px; color: white; text-transform: uppercase; margin-right: 10px; }
      &--valid{ background-color: $vert;  }
      &--delete{ background-color: $color1;  }
      &:hover{ text-decoration: none; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Order/OrderModal.vue